<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/tick.svg?raw'
export default {
  name: 'IconTick',
  components: {
    BwrIcon,
  },
  props: {
    animate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ svgContent }),
}
</script>
